export enum EntityStoreKey {
  legalAgreements = 'legalAgreements',
}

export type LegalAgreementsParams = {
  version: 'openai';
};

export type LegalAgreementsPayload = {
  version: 'openai';
  html: string;
};
